// Small shared skeleton helpers for the client portal
import React from "react";
import { Box, Paper, Skeleton } from "@mui/material";

/** Rows that mimic list items inside a card (dashboard preview lists) */
export function InlineListSkeleton({ rows = 4 }) {
  return (
    <Box>
      {Array.from({ length: rows }).map((_, i) => (
        <Box key={i} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
          <Box sx={{ flex: 1, pr: 2 }}>
            <Skeleton variant="text" width="40%" height={18} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="28%" height={14} />
          </Box>
          <Skeleton variant="rounded" width={88} height={32} />
        </Box>
      ))}
    </Box>
  );
}

/** Full-width card placeholder (used on focused pages) */
export function FullCardSkeleton({ rows = 6 }) {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Skeleton variant="text" width="40%" height={20} />
        <Skeleton variant="rounded" width={96} height={36} />
      </Box>
      <Skeleton variant="text" width="28%" height={14} />
      {/* optional extra rows for long lists */}
      {Array.from({ length: Math.max(0, rows - 2) }).map((_, i) => (
        <Skeleton key={i} variant="text" width={`${20 + (i % 3) * 10}%`} height={14} />
      ))}
    </Paper>
  );
}